export default "__VITE_ASSET__019c0870__"